
import { City, CityPoint } from "@/models/City";
import { MapOptions } from "@/models/Map";
import { QuestMapPoi, MAP_STATUS } from "@/models/MapPois/Quest/QuestMapPoi";
import { forIn } from "lodash";
import ProgressDialog from "@/components/Base/ProgressDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import Map from "../../../Base/Map.vue";
import { Game } from "@/models/Game";
import ImageBox from "@/components/Base/ImageBox.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import QuestGameErrors from "@/utils/ErrorQuest/QuestGameErrors";
import QuestGameWarnings from "@/utils/ErrorQuest/QuestGameWarnings";
import DateHelper from "@/utils/DateHelper";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { Season } from "@/models/GameType";
import ImageSelector from "@/components/Base/ImageSelector.vue";

@Component({
  components: { Map, ProgressDialog, ImageBox, ImageSelector },
})
class CreateQuestPoi extends Vue {
  @Prop({ default: null }) readonly citySlug!: string;
  @Prop({ default: null }) readonly gameUid!: string;
  adminName = "";
  dialogName = "";
  errorMessage: string[] = [];
  warnMessage = false;
  showImageSelectorBool = false;
  selectedCity = "";
  selectedSeason = "";
  lat = 0;
  lng = 0;
  place = {} as any;
  poiType = "person";
  getSelectMapStatus = "active";
  active = true;
  visible = true;
  getImage = "";

  get getLocations(): any[] {
    const arr: any = [];
    forIn(this.getCityData.locations, (val: CityPoint) => {
      var mapPoiExist = this.getMapPoiData.find(
        (x) => x.loc.loc_uid === val.slug
      );
      if (mapPoiExist === undefined && val.slug !== "centre_point") {
        var options = { value: val.slug, text: val.name.en };
        arr.push(options);
      }
    });
    return arr;
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getLocationsArray(): CityPoint[] {
    const arr: CityPoint[] = [];
    forIn(this.getCityData.locations, (val: CityPoint) => {
      arr.push(val);
    });
    return arr;
  }

  get getQuestData(): Quests[] {
    return this.$store.state.questStore.quest;
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }
  get getNotes(): string {
    if (this.getCityData.locations[this.selectedCity] === undefined) {
      return "";
    }
    return this.getCityData.locations[this.selectedCity].notes || "";
  }

  get getPoiType(): string[] {
    return this.$store.state.mapPoiStore.poiTypes;
  }

  get getMapStatus(): string[] {
    return MAP_STATUS;
  }

  get getLocationsMap(): MapOptions[] {
    var arr: MapOptions[] = [];
    try {
      forIn(this.getCityData.locations, (val: CityPoint) => {
        var mapPoiExist = this.getMapPoiData.find(
          (x) => x.loc.loc_uid === val.slug
        );
        if (mapPoiExist === undefined) {
          if (val.slug !== "centre_point") {
            var locationMarker: MapOptions = {
              position: {
                lat: val.lat_long.latitude,
                lng: val.lat_long.longitude,
              },
              title: val.name.en,
              slug: val.slug,
              draggable: false,
              clickable: true,
              zIndex: 100,
              icon: require("@/assets/images/map/city-gray.svg"),
            };

            arr.push(locationMarker);
          }
        }
      });
      this.getMapPoiData.forEach((val: QuestMapPoi) => {
        var cityData = this.getLocationsArray.find(
          (x: CityPoint) => val.loc.loc_uid === x.slug
        );
        var locationMarker2: MapOptions = {
          position: {
            lat:
              cityData !== undefined && cityData.lat_long !== undefined
                ? cityData!.lat_long.latitude
                : val.loc.override_ll.latitude,
            lng:
              cityData !== undefined && cityData.lat_long !== undefined
                ? cityData!.lat_long.longitude
                : val.loc.override_ll.longitude,
          },
          title: val.title.en,
          draggable: false,
          clickable: true,
          slug: val.key,
          radius: val.loc.geo_rad_m,
          color: val.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
          zIndex: 1001,
          icon: DateHelper.getGreyMapQuestImage(val),
        };
        arr.push(locationMarker2);
      });
      arr.push(this.getCurrentMapLocation);
      return arr;
    } catch (error) {
      console.log(error);
      return arr;
    }
  }

  get getCurrentMapLocation(): MapOptions {
    var val = this.getCityData.locations[this.selectedCity];
    if (val !== undefined) {
      this.lat = val.lat_long.latitude;
      this.lng = val.lat_long.longitude;
      var locationMarker: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: val.name.en,
        draggable: true,
        clickable: true,
        slug: val.slug,
        radius: 10,
        color: "#E06B6B",
        zIndex: 10011,
        icon: require("@/assets/images/map/map-pin-pink.svg"),
      };
      return locationMarker;
    } else {
      var locationMarker2: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: "new_pin",
        draggable: true,
        clickable: true,
        slug: "new_pin",
        radius: 10,
        color: "#E06B6B",
        zIndex: 10011,
        icon: require("@/assets/images/map/map-pin-pink.svg"),
      };
      return locationMarker2;
    }
  }

  get centerPoint(): any {
    return {
      latitude: this.lat,
      longitude: this.lng,
    };
  }

  get getSeason(): Season {
    return this.$store.state.gameStore.gameType.filter(
      (t: Season) => t.slug == this.getGame.seas_uid
    )[0];
  }

  checkAmenitiesWarning(): void {
    if (this.poiType == "amenities") {
      this.warnMessage = true;
    } else {
      this.warnMessage = false;
    }
  }

  created(): void {
    this.lat = this.getCityData.centre_point.latitude;
    this.lng = this.getCityData.centre_point.longitude;
  }
  cancel(): void {
    this.$emit("closeDialog");
  }
  savePoi(): void {
    this.$v.$touch();
    if (this.$v.$anyError) {
      this.errorMessage.push("Please fix the errors");
    } else {
      this.errorMessage = [];
      if (this.adminName.trim().length < 3) {
        this.errorMessage.push("Please enter a valid display name");
      }
      if (this.errorMessage.length == 0) {
        this.$emit("closeDialog");
        this.$bvModal.show("team-modal-spinner");
        var data = {
          admin_name: this.adminName,
          location: this.selectedCity,
          gameUid: this.gameUid,
          lat: this.lat,
          lng: this.lng,
          cityData: this.getCityData,
          gameData: this.getGame,
          image: this.getImage,
          type: this.poiType,
          active: this.active,
          visible: this.visible,
          mapStatus: this.getSelectMapStatus,
        };

        this.$store.dispatch("mapPoiStore/insertNewQuestPoi", data).then(() => {
          new QuestGameErrors(
            this.gameUid,
            this.getMapPoiData,
            this.getQuestData,
            this.getCityData,
            this.getSeason,
            this.$store.state.gameStore.games
          ).checkGameErrors();
          new QuestGameWarnings(
            this.gameUid,
            this.getMapPoiData,
            this.getQuestData,
            this.getCityData,
            this.getSeason,
            this.$store.state.gameStore.games
          ).checkGameWarnings();
          this.$bvModal.hide("team-modal-spinner");
        });
      }
    }
  }

  changeMapStatus(value: string): void {
    this.getSelectMapStatus = value;
    if (value === "inactive") {
      this.visible = true;
      this.active = false;
    }
    if (value === "active") {
      this.visible = true;
      this.active = true;
    }
    if (value === "hidden") {
      this.visible = false;
      this.active = true;
    }
    if (value === "hidden(inactive)") {
      this.visible = false;
      this.active = false;
    }
  }

  openLocation(slug: string): void {
    this.selectedCity = slug;
  }
  mapData(place: any): void {
    this.selectedCity = "";
    this.lat = place.latitude;
    this.lng = place.longitude;
  }

  returnImagePath(path: string): void {
    this.getImage = this.getImagePath + "" + path;
    this.showImageSelectorBool = false;
  }

  clearImage(): void {
    this.getImage = "";
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGame.gt_uid +
      "/seasons/" +
      this.getGame.seas_uid +
      "/img/poi/"
    );
  }

  showImageSelector(): void {
    this.showImageSelectorBool = true;
  }

  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }

  @Validations()
  validations = {
    adminName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(160),
    },
  };
}

export default CreateQuestPoi;
